<h1 mat-dialog-title>
    Arbeitszeiten exportieren s
    <span class="spacer"></span>
    <button
        *ngIf="showEmployeeSelect"
        app-round-button
        [matBadge]="filterAmount$ | async"
        matTooltip="Filter"
        [matBadgeOverlap]="true"
        [matBadgeHidden]="!(filterAmount$ | async)"
        (click)="employeeFilter.Toggle()"
        [Active]="employeeFilter.ShowFilter"
    >
        <fa-icon icon="filter"></fa-icon>
    </button>
</h1>
<app-filter-card UnlimitedHeight #employeeFilter [Settings]="filterSettings$ | async" [LargeCard]="true" [Values]="filterValues$ | async" (ValuesChange)="filterValues$.next($event)"></app-filter-card>
<app-detail-list-template *ngIf="TemplateData$ | async as data; else loading" [Editing]="true" [Inline]="true" [Data]="data" ></app-detail-list-template>
<mat-dialog-actions>
    <button app-button mat-dialog-close Inverted Color="cancel">Abbrechen</button>
    <button app-button (click)="Export()" [Disabled]="Form.invalid" [IsLoading]="ls.IsLoading$ | async">Exportieren</button>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
